import { render } from "./Home2024.vue?vue&type=template&id=cdeb0756"
import script from "./Home2024.js?vue&type=script&lang=js"
export * from "./Home2024.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__